import React from 'react';
import Home from "./Home";
import Connect from './Connect';
import Products from "./Products";
import Features from './Features';
import Trending from "./Trending";
import Connect2 from './Connect2';

const Fact = () => {


    return (
        <>
            <Home />
            <Connect />
            <Products />
            <Features />
            <Trending />
            <Connect2 />
        </>
    );
};

export default Fact;